import { render, staticRenderFns } from "./PageCollections.vue?vue&type=template&id=5160e5ea"
import script from "./PageCollections.vue?vue&type=script&lang=js"
export * from "./PageCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports